import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { AppNotification, AppSurvey, JoiApp, JoiAppInfo, SurveySelectData, appStatusToText } from 'globals/store/app.data';
import { JoiEvent, Venue } from 'globals/store/events.data';
import { Dictionary } from '@ngrx/entity';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { PublishReselectorData, publicEventDataReselector } from 'src/app/store/reselectors/events.reselector';
import { PublicEventData } from 'globals/store/public.model';
import { filterActions, filterPageTypes, filtersFeature } from 'src/app/store/filters.era';
import { SliderImageDialogComponent, SliderImageDialogData } from '../../components/branding/slider-image-dialog.component';
import { BrandOption, BrandingData, BrandingSelectData, SliderImage } from 'globals/store/publish.data';
import { removeFromListByIndex, sleepForMS } from '../../helpers/helpers';
import { JoiAccount } from 'globals/store/accounts.data';
import { ManageBrandingComponent, ManageBrandingData } from '../../components/branding/manage-branding.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { PublishStatus, getDefaultProgramTabNames } from 'globals/store/share.data';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { appInstructionsReselector, appNotificationsReselector, appUserCountReselector } from '../../store/reselectors/apps.reselector';
import { publishStatusToColor } from '../program/program.publish.view.component';
import { AppNotificationDialogComponent, AppNotificationDialogData, NotificationDialogReturnData } from './app-notification-dialog.component';
import { ChangeDetectorRef } from '@angular/core';
import { AppNotificationsListComponent } from './app-notifications-list.component';
import { ManageSurveyComponent } from './manage-survey.component';
import { AppSurveysListComponent } from './app-surveys-list.component';
import { InputDialogComponent, InputDialogData, InputDialogReturnData } from '../../components/wizards/input.dialog.component';
import { FilterDialogComponentParams } from '../../components/filters/filters-ui.models';
import { FiltersDialogComponent } from '../../components/filters/filters-dialog.component';
import { appDisplayOptionsNestedFieldCheckGroups } from '../program/program.publish.view.display-options';
import { NestedChecksDialogComponent, NestedChecksDialogData, NestedChecksReturnData } from '../../components/wizards/nested-checks.dialog.component';
import { VenueSelection } from 'globals/store/programs.data';
import { venueSelectionsReselector } from '../../store/reselectors/programs.reselector';
import { select } from '@ngrx/store';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { QRCodeComponent } from './qr-code.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { CommonModule } from '@angular/common';
import { BlackBarWrapperComponent } from 'src/app/components/wrappers/black-bar-wrapper.component';
import { ScrollableWrapper } from 'src/app/components/wrappers/scrollable-wrapper.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { PublishTimelineComponent } from 'src/app/components/publish-timeline/publish-timeline';
import { BrandingTextComponent } from 'src/app/components/branding/branding-text.component';
import { BrandingBlockWrapperComponent } from 'src/app/components/branding/branding-block.component';
import { SliderImageComponent } from 'src/app/components/branding/slider-image.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { AppBrandingComponent } from './app-branding.component';
import { SurveyResponsesComponent } from './survey-responses.component';
import { getOneStorePromise } from 'src/app/store/ui.era';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { MatButtonModule } from '@angular/material/button';

type MenuItem = 'app' | 'comms'
type AppMenuItem = 'design' | 'configure' | 'access' | 'activate' | 'share'
type CommMenuItem = 'notifications' | 'forms' | 'responses'
@Component({
    selector: 'app-manager',
    templateUrl: './app-manager.html',
    styleUrls: ['./app-manager.scss', '../../page.scss', '../program/program.publish.view.scss'],//
    standalone: true,
    imports: [TrafficLightComponent, MatButtonModule, IdsToItemsPipe, AppSurveysListComponent, QRCodeComponent, JoiNavWrapper, CommonModule, BlackBarWrapperComponent, ScrollableWrapper, GreyWrapperComponent, ActionButtonComponent, AppNotificationsListComponent, PublishTimelineComponent, BrandingTextComponent, BrandingBlockWrapperComponent, SliderImageComponent, IconComponent, IconTextComponent, LoaderComponent, ToggleTabComponent, JoiInputComponent, TipTextComponent, AppBrandingComponent, SurveyResponsesComponent],
})
export class AppManagerComponent extends Wrapper<AppManagerComponent> implements OnInit {
  @Input() appId: string
  @Input() startMobile: boolean
  @Output() close: EventEmitter<null> = new EventEmitter()
  appInfo: JoiAppInfo
  appNotifications: AppNotification[] = []
  appLink = 'joiapp://mobile.joi.events/'
  androidAppStoreLink = 'https://play.google.com/store/apps/details?id=events.joi.mobile'
  appleAppStoreLink = 'https://apps.apple.com/us/app/joi-event-app/id6474649537'
  
  userCount: number
  app: JoiApp
  event: JoiEvent
  account: Partial<JoiAccount>
  sponsors: Dictionary<Sponsor> = {}
  exhibitors: Dictionary<Exhibitor> = {}
  performers: Dictionary<Performer> = {}
  loadingPreview = true

  topMenuItems: MenuItem[] = ['app', 'comms']
  topMenuItemMap: { [k in MenuItem]: string } = { app: 'APP', comms: 'COMMS' }
  topMenuItem: MenuItem = 'app'

  appMenuItems: AppMenuItem[] = ['design', 'configure', 'access', 'activate', 'share' ]
  appMenuItemMap: { [k in AppMenuItem]: string } = { design: 'DESIGN', configure: 'CONFIGURE', access: 'ACCESS', activate: 'ACTIVATE', share: 'SHARE' }
  hiddenAppMenuItems: Set<AppMenuItem> = new Set(['design', 'configure'])
  appMenuItem: AppMenuItem = 'configure'

  commMenuItems: CommMenuItem[] = ['notifications', 'forms', 'responses' ]
  commMenuItemMap: { [k in CommMenuItem]: string } = { notifications: 'PUSH NOTIFICATIONS', forms: 'EVALUATION FORMS', responses: 'RESPONSES' }
  commMenuItem: CommMenuItem = 'notifications'

  hideTimeline = false
  filtersLoaded = false
  venueSelections: VenueSelection[]

  eventDataPreview: PublicEventData
  previewVenue: Venue
  brandingData: BrandingData
  canEditAccount: boolean
  instructions = ""
  showSuccess = false
  processing = false
  statusToColor = publishStatusToColor
  statusToText = appStatusToText
  emptyShareMessage = `Nothing here!
  Looks like you haven't shared anything yet!
  Head back over to the Activate tab to share your app.`
  @ViewChild('appNotificationList') appNotificationList: AppNotificationsListComponent
  @ViewChild('appSurveyList') appSurveyList: AppSurveysListComponent

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('exhibitors', 'entities'), 'exhibitors')
    this.subProp(this.store.select('sponsors', 'entities'), 'sponsors')

    this.store.dispatch(filterActions.clearFilterGroup(filterPageTypes.appTable))
    this.selectProp(clipboardEditingPrivilegesReselector, null, 'canEditAccount')
    this.selectProp(venueSelectionsReselector, null, 'venueSelections')
  }

  ngOnInit() {
    if (this.startMobile) this.appMenuItem = 'access'
    const brandingSelectData: BrandingSelectData = {
      type: 'app',
      appId: this.appId
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.selectProp(appUserCountReselector, this.appId, 'userCount')
    this.selectProp(appNotificationsReselector, this.appId, 'appNotifications')
    this.subCallback(this.store.select('apps', 'entities', this.appId), appInfo => {
      this.appInfo = jsonCopyObject(appInfo)
      if (!this.filtersLoaded) {
        this.filtersLoaded = true
        this.filtersService.filterAndLoadTimelineFilters(appInfo.filters, 'app')
      }
    })
    this.subProp(this.store.select('apps', 'apps', this.appId), 'app')
    this.subProp(this.store.select(appInstructionsReselector, this.appId), 'instructions')
    this.subCallback(this.store.select(publicEventDataReselector, { appId: this.appId, filter: true }), ({ eventData, linkedVenue }: PublishReselectorData) => {
      if (eventData) this.loadingPreview = false
      this.eventDataPreview = eventData
      this.previewVenue = linkedVenue
      // console.log({ linkedVenue })
    })
  }

  async editNameAndDescription() {
    const data: InputDialogData = {
      title: 'App Name and Description',
      placeholder: 'Name',
      header: 'Update your app name and description',
      successLabel: 'UPDATE',
      currentValue: this.appInfo.title,
      secondValue: this.appInfo.description,
      secondPlaceholder: 'Update App Description',
      emptyOK: false,
      backgroundColor: this.uiService.labelsByType.event.color,
    }
    const result = await this.openDialogGetResult<InputDialogReturnData>(InputDialogComponent, { width: '480px', disableClose: true, data })
    if (!result) return
    const [ title, description ] = result.values
    this.appInfo.title = title
    this.appInfo.description = description || ''
    this.updateAppInfo()
  }


  async openFilters() {

    const filterGroupings = await this.filtersService.buildTimelineViewFilterUI('app')
    const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.app, filterGroupings }}
    const filtersApplied = await openDialogGetResult(this.dialog, FiltersDialogComponent, params)
    if (!filtersApplied) return

    const filters = await getOneStorePromise(this.store, select(filtersFeature.selectApp))
    Object.keys(filters).filter(k => !filters[k]).forEach(k => delete filters[k])
    this.appInfo.filters = filters
    this.updateAppInfo()

  }

  async editFields() {
    console.log("Edit fields called...")
    const nestedCheckGroups = jsonCopyObject(appDisplayOptionsNestedFieldCheckGroups)
    const deselectedIds = this.appInfo.excludedFieldIds || []
    const data: NestedChecksDialogData = {
      title: 'Display options',
      successLabel: 'SAVE',
      deselectedIds,
      backgroundColor: this.uiService.labelsByType.event.color,
      nestedCheckGroups,
      tabNameMap: this.appInfo.tabNames || {},
      radioChoices: {
        timeline: deselectedIds.includes('breakDays') ? 'breakDays' : 'default'
      }
    }
    console.log({ data })

    if (this.venueSelections.length) { 
      const pageDisplayOptions = nestedCheckGroups.find(g => g.groupName === 'App display options')
      const dropdownOptions = this.venueSelections.map(s => ({ title: s.displayedTitle, id: s.id }))

      const venueId = this.appInfo.venueId || ( this.previewVenue ? this.previewVenue.id : null )
      const currentSelection = venueId ? dropdownOptions.find(o => o.id === venueId) : dropdownOptions[0]

      pageDisplayOptions.endingTabDropdown = {
        title: 'Primary Venue',
        id: 'primaryVenue',
        currentSelection,
        dropdownOptions,
        dropdownTitle: 'SELECT PRIMARY VENUE',
        toggleOptions: ['OFF', 'ON'],
      }
      data.currentValues = { 'venue': venueId }
    }  
    console.log(data)

    const result = await openDialogGetResult<NestedChecksReturnData>(this.dialog, NestedChecksDialogComponent, { width: '480px', disableClose: true, data })
    if (!result) return
    console.log(result)
    // let venueId = result.valueSelections.venue 
    // venueId = result.deselectedIds.includes('primaryVenue') || !venueId ? null : venueId

    this.appInfo.excludedFieldIds = result.deselectedIds || []
    this.appInfo.tabNames = result.tabNameMap || {}
    this.hideTimeline = true
    this.updateAppInfo()
    await sleepForMS(100)
    this.hideTimeline = false
    this.appInfo.tabNames = result.tabNameMap

  }

  
  async openNotification(notification?: AppNotification) {

    const isNew = !notification
    this.changeDetectorRef.detach()
    if (!notification) {
      notification = {
        id: `${this.event.eventId}-${this.appId}-${createId()}`,
        appId: this.appId,
        eventId: this.event.eventId,
        appTitle: this.appInfo.title || '',
        timeZone: this.programService.defaultTimeZoneId,
        type: 'standard',
        active: false,
        linkType: null,
        pushTime: new Date().getTime() + 60 * 5 * 1000,
        title: '',
        message: ''
      }
      this.appInfo.notifications[notification.id] = notification
      this.appInfo.notificationIds.push(notification.id)
      await this.appService.createNotification(notification)
    }
    
    const data: AppNotificationDialogData = {
      appId: this.appInfo.id,
      notificationId: notification.id
    }
    const result = await openDialogGetResult<AppNotification>(this.dialog, AppNotificationDialogComponent, { width: '600px', disableClose: true, data })
    if (!result && isNew) this.deleteNotification(notification.id)
    else if (result) {
      result.active = true
      await this.appService.updateNotification(result)
    }
    this.changeDetectorRef.reattach()
  }

  deleteNotification(id: string) {
    this.appService.deleteNotification(id);
  }

  async createSurvey() {
    const id = createId()
    const newSurvey: AppSurvey = {
      id,
      timeZone: this.programService.defaultTimeZoneId,
      pushTime: new Date().getTime(),
      title: '',
      customQuestions: []
    }
    this.appInfo.surveys[id] = newSurvey
    console.log({ newSurvey, appInfo: this.appInfo })
    this.appInfo.surveyIds.push(id)
    await this.appService.updateAppInfo(this.appInfo) // need to create survey first because of reselectors with timezone
    this.openSurvey(id)
  }

  async openSurvey(id: string) {
    this.changeDetectorRef.detach()
    const data: SurveySelectData = {
      appId: this.appInfo.id,
      surveyId: id
    }
    await openDialogGetResult<void>(this.dialog, ManageSurveyComponent, { disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  pushSurvey(id: string) {
    this.appInfo.surveys[id].pushTime = new Date().getTime()
    this.appService.updateAppInfo(this.appInfo)
    this.appSurveyList.setNow()
  }
  
  deleteSurvey(id: string) {
    delete this.appInfo.surveys[id]
    console.log({ id, appInfo: this.appInfo })
    this.appService.updateAppInfo(this.appInfo)
  }
  
  deactivateSurvey(id: string) {
    this.appInfo.surveys[id].active = false
    this.appService.updateAppInfo(this.appInfo)
  }

  updateSurvey(survey: AppSurvey) {
    this.appInfo.surveys[survey.id] = survey
    this.appService.updateAppInfo(this.appInfo)
  }


  pushTest(notificationId: string) {
    console.log("SHOULD BE PUSH TESTING " + notificationId)
  }

  setupTestingPhone() {
    console.log("Should be setting up testing phone")
  }

  clearTestingPhone() {
    console.log("Should be clearing testing phone")
  }

  copyId() {
    navigator.clipboard.writeText(this.appInfo.title)
  }

  copyInstructions() {
    navigator.clipboard.writeText(this.instructions)
  }


  updateAppInfo() {
    this.appService.updateAppInfo(this.appInfo)
  }

  succeedTemporarily() {
    this.showSuccess = true
    setTimeout(() => this.showSuccess = false, 3000)
  }

  async updateApp(status: PublishStatus) {
    console.log("UPDATE CALLED")
    this.processing = true;
    try {
      console.log({ appInfo: this.appInfo, status, brandingData: this.brandingData })
      await this.appService.updateApp(this.appInfo, status, this.brandingData)
    } catch (error) {
      console.error(error)
    } finally {
      this.processing = false
    }
  }

  async changeBrandingOption(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'app', appId: this.appId, onAccount: true }
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

  async editSliderImage(index: number) {
    const data: SliderImageDialogData = {
      sliderImage: index === null ? null : this.appInfo.homePageData.sliderImages[index],
      accountId: this.account.id,
      eventId: this.event.eventId,
      imageType: 'mobile-slider'
    }
    const sliderImage = await this.openDialogGetResult<SliderImage | { delete: true }>(SliderImageDialogComponent, { width: '440px', disableClose: true, data })
    if (!sliderImage) return
    if ('delete' in sliderImage) {
      removeFromListByIndex(this.appInfo.homePageData.sliderImages, index)
    } else if (index === null) {
      if (!this.appInfo.homePageData.sliderImages) this.appInfo.homePageData.sliderImages = []
      this.appInfo.homePageData.sliderImages.push(sliderImage)
    } else {
      this.appInfo.homePageData.sliderImages[index] = sliderImage
    }
    this.updateAppInfo()
  }


}

